import React from 'react'
import NHFetch from '../../../utils/NHFetch';
export default class footer extends React.Component {
    constructor() {
        super()
        this.state = {
            copyright:''
        }
    }

    componentDidMount() {
        NHFetch('front/zhxg-unauth/xtglSchoolMng/getCopyrightInformation', 'GET').then(res => {
            if (res&&res.data) {
                this.setState({copyright: res.data});
            }
        });
    }

    render() {
        const {copyright} = this.state;
        return (
            <div style={{ fontSize: '12px', color: '#7d7d7d', textAlign: 'center', lineHeight: '40px' }}>
               {copyright}
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./components/common/NHFooter/index.js